import React, {PureComponent} from "react"
import qs from "qs"
import {connect} from "@irati/store"

import session from "@irati/auth/services/session"
import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import {H1} from "@irati/ui/src/Typography"
import History from "@irati/utils/history"
import {idpLogin, workOSLogin} from "@irati/sso/services/sso"
import AuthActions, {SSOLoginInput} from "@irati/auth/store/actions/AuthActions"
import authentication from "@irati/auth"
import loginService from "@irati/auth/services/login"
import FormattedMessage from "@irati/utils/lang"
import tokens from "@irati/auth/services/tokens"

import LoginBlock from "../../../components/LoginBlock"
import LoginBackground from "../../../components/LoginBackground"
import IDPLoginError from "./IDPLoginError"

interface Props {
  singleSignOn: (data: SSOLoginInput) => Promise<void>
}

interface State {
  load: Promise<any> | null
}

class LoginSamlIDP extends PureComponent<Props, State> {
  state: State = {
    load: null
  }

  componentDidMount() {
    const load = window.location.search ? this.getWorkOSResponse() : this.getSamlResponse()
    this.setState({load})
  }

  parseState = (state: string) => {
    const base64 = state.replace(/-/g, "+").replace(/_/g, "/")
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    )
    return JSON.parse(jsonPayload)
  }

  getWorkOSResponse = () => {
    const {code, state} = qs.parse(window.location.search, {ignoreQueryPrefix: true})

    if (!code) throw new Error("No code found")

    const parsedState = state ? this.parseState(state) : undefined
    return workOSLogin(code as string, parsedState?.businessId).then((data) => {
      const {accessToken, business} = data
      if (!accessToken) throw new Error("No WorkOS Response found")
      tokens.set({accessToken})
      const {subdomain} = business!
      const clientState = parsedState?.clientState?.url.split("?")[1].replace("?", "")
      return session.postCrossDomain(subdomain, {accessToken, state: clientState}, {pathname: "/welcome/login/code"})
    })
  }

  getSamlResponse = () => {
    return session.getThenRemove(["SAMLResponse"]).then(({SAMLResponse}) => {
      if (!SAMLResponse) throw new Error("No Saml Response found")
      return idpLogin(SAMLResponse).then(({accessToken}) => {
        return loginService.ssoLogin(accessToken).then(() => {
          History.replace("/")
        })
      })
    })
  }

  render() {
    const {load} = this.state
    const idNamespace = id("login-saml-idp", this.props, {force: true})

    return (
      <LoginBackground>
        <LoginBlock id={idNamespace}>
          <H1 marginBottom={3}>
            <FormattedMessage id="platform.login.idp.header" />
          </H1>
          <Loading load={load} Error={IDPLoginError} />
        </LoginBlock>
      </LoginBackground>
    )
  }
}

const actions = (dispatch: any) => {
  return {
    singleSignOn: (data: SSOLoginInput) => dispatch(AuthActions.singleSignOn(authentication.userTenant(), data))
  }
}

export default connect(null, actions)(LoginSamlIDP)
